import React from 'react';
import { TextField } from '@mui/material';
import { handleNumericFocus } from '../utils/inputUtils';

export const BalanceInput = React.memo(({ initialValue, onSave, disabled }) => {
    const [value, setValue] = React.useState('');

    // Update local state when initialValue changes from parent
    React.useEffect(() => {
        if (initialValue !== undefined) {
            setValue(new Intl.NumberFormat('en-US').format(initialValue));
        }
    }, [initialValue]);

    const handleBlur = (e) => {
        const raw = e.target.value.replace(/,/g, '');
        const num = parseFloat(raw);
        if (!isNaN(num)) {
            setValue(new Intl.NumberFormat('en-US').format(num));
            const prevNum = (initialValue !== undefined && initialValue !== null) ? parseFloat(initialValue) : 0;
            if (Math.abs(num - prevNum) > 0.0001) {
                onSave(num);
            }
        } else {
            // Restore previous valid value
            setValue(new Intl.NumberFormat('en-US').format(initialValue || 0));
        }
    };

    const handleFocus = (e) => {
        handleNumericFocus(e, (ev) => {
            // Strip commas for cleaner editing
            setValue(ev.target.value.replace(/,/g, ''));
        });
    };

    return (
        <TextField
            variant="standard"
            size="small"
            disabled={disabled}
            value={value}
            onChange={(e) => {
                // Allow only numbers, one dot, and commas
                const val = e.target.value;
                if (/^[0-9,.]*$/.test(val)) {
                    setValue(val);
                }
            }}
            onBlur={handleBlur}
            onFocus={handleFocus}
            slotProps={{
                input: {
                    disableUnderline: disabled
                },
                htmlInput: {
                    style: {
                        textAlign: 'right',
                        fontWeight: 600,
                        WebkitTextFillColor: 'inherit',
                        color: 'inherit',
                        cursor: disabled ? 'default' : 'text'
                    },
                    inputMode: 'decimal'
                }
            }}
            sx={{
                width: 100,
                '& .MuiInputBase-root.Mui-disabled': {
                    color: 'text.primary',
                },
                '& .MuiInputBase-input.Mui-disabled': {
                    WebkitTextFillColor: 'inherit !important',
                    color: 'text.primary !important',
                    cursor: 'default',
                },
                '& .MuiInput-underline.Mui-disabled:before': {
                    borderBottom: 'none !important',
                },
                '& .MuiInput-underline.Mui-disabled:after': {
                    borderBottom: 'none !important',
                }
            }}
        />
    );
});

export default BalanceInput;
